import { QueryKeys } from '../../../enums/queryKeys'

export const getBillTimelineQueryKey = (
  billId: string,
  organizationId?: string,
): [QueryKeys, string, string | undefined] => [QueryKeys.BillTimeline, billId, organizationId]
